// Product lifecycle options
export const PRODUCT_LIFECYCLE_ACTIVE = 'A';

export const PRODUCT_LIFECYCLE_DISCONTINUED = 'P';

export const PRODUCT_LIFECYCLE_WAITING_FOR_SELECTION = 'O';

export const PRODUCT_LIFECYCLE_PENDING = 'X';

// Product status options
export const PRODUCT_STATUS_PRODUCTIZED = '14';

export const PRODUCT_STATUS_PRE_PRODUCT = '8';

export const OFFER_GROUP_ACCESSORIES = 'Oheistuotteet';

export const TAX_GROUP_ETHYL_OVER_2_8 = '45';

export const TAX_GROUP_ETHYL_OVER_2_8_UNDER_10 = '42';
